import { useContext } from 'react'
import AttachmentContext from './AttachmentContext'

const useAttachmentContext = () => {
    return useContext(AttachmentContext)
}

export default useAttachmentContext
